import {
    defaultBaseQuery,
    buildFormData,
    transformRequest,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const dashboardapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'dashboardapi',
    endpoints: (builder) => ({
        getSkillPassportProfile: builder.query({
            query: () => ({
                url: `/student/dashboard`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        generateSkillPassportResume: builder.query({
            query: () => ({
                url: `/student/dashboard/resume`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        generateSkillPassport: builder.query({
            query: () => ({
                url: `/student/dashboard/skill-passport`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        uploadSkillPassportProfilePicture: builder.mutation({
            query: (file) => ({
                url: `/student/profile-photo`,
                method: 'POST',
                body: buildFormData({ file })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getSkillPassportProfilePicture: builder.query({
            query: () => ({
                url: `/student/profile-photo`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addSocialProfileLink: builder.mutation({
            query: (params) => ({
                url: `/student/dashboard/social-link`,
                method: 'POST',
                params: params
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        saveJobSkills: builder.mutation({
            query: (data) => ({
                url: `/student/skills/job-skills`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useLazyGetSkillPassportProfileQuery,
    useLazyGenerateSkillPassportResumeQuery,
    useLazyGenerateSkillPassportQuery,
    useUploadSkillPassportProfilePictureMutation,
    useLazyGetSkillPassportProfilePictureQuery,
    useAddSocialProfileLinkMutation,
    useSaveJobSkillsMutation
} = dashboardapi;

export default dashboardapi;
